<template>
    <div class="container">
        <van-nav-bar title="退款成功" left-text="" left-arrow @click-left="onClickLeft" />
        <img class="img" src="../../assets/img/success.png" alt="">
        <p class="p1">退款成功</p>
        <div class="box">
            <van-button type="primary" block @click="changePage()">查看退款记录</van-button>
        </div>
    </div>
</template>
  
<script>
import { NavBar, Icon, Toast, Loading, Button } from 'vant';
export default {
    data() {
        return {
        };
    },
    components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Toast.name]: Toast,
        [Loading.name]: Loading,
        [Button.name]: Button,
    },
    methods: {
        changePage() {
            this.$router.push({ path: "refundList.html" })
        },

        onClickLeft() {
            this.$router.go(-1);
        },
    },
    computed: {
    },
    created() {

    },
    mounted() { },
    destroyed() { }
}
</script>
  
<style lang="less" scoped>
body,
html {
    width: 100%;
    height: 100%;
    background: #F0F4F7;
    text-align: center;
}

.container {
    width: 100%;
    height: 100%;
    letter-spacing: 0px;
    background: #F0F4F7;
}

.img {
    width: 120px;
    height: 120px;
    display: block;
    margin:0px auto;
    margin-top: 110px;
}

.p1 {
    text-align: center;
    font-size: 18px;
    line-height: 3;
}

.box {
    width: 94%;
    position: fixed;
    bottom: 20px;
    left: 3%;

}
</style>
  